import classes from './Account.module.css';
import { Link } from 'react-router-dom';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const Account = ({ goal_amount, balance, id, type, acc_number, name }) => {
  const goalPercent = goal_amount
    ? Math.floor((balance / goal_amount) * 100)
    : null;

  return (
    <Link to={`/accountDetail/?acctId=${id}`}>
      <div
        className={`${classes.main} ${
          type === 'CREDIT' ? classes.credit : classes.debit
        }`}
      >
        <h4 className={classes.bold}>
          {acc_number
            ? acc_number?.toString().slice(-4).padStart(16, '*')
            : '****'}
        </h4>
        <div className={classes.bottom}>
          <div>
            <p>{name}</p>
            <p className={classes.small_title}>{type}</p>
          </div>
          {goal_amount && balance ? (
            <div className={classes.circle}>
              <CircularProgressbar
                value={goalPercent}
                text={goalPercent >= 100 ? '✅' : goalPercent + '%'}
                styles={buildStyles({
                  pathColor: `#7984EE`,
                  textColor: `#F05454`,
                })}
              />
            </div>
          ) : (
            ''
          )}
        </div>
        <div className={classes.bottom}>
          <div>
            <p>Balance</p>
            <span className={classes.balance}>$ {balance.toFixed(2)}</span>
          </div>
          {goal_amount ? (
            <div>
              <p>Goal</p>
              <span className={classes.small_title}>$ {goal_amount}</span>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </Link>
  );
};

export default Account;
